module.exports = __webpack_public_path__ + "static/media/de_add_to_google_wallet.b168e793.svg";